import { createFeature, createReducer } from '@ngrx/store';

import { newOpportunitySearchCustomersDialogReducers } from './new-opportunity-search-customers-dialog.reducer';
import { newOpportunitySearchCustomersDialogInitialState } from './new-opportunity-search-customers-dialog.state';

export const newOpportunitySearchCustomersDialogFeature = createFeature({
  name: 'newOpportunitySearchCustomersDialog',
  reducer: createReducer(
    newOpportunitySearchCustomersDialogInitialState,
    ...newOpportunitySearchCustomersDialogReducers,
  ),
});
